import { Link, useLocation } from "react-router-dom";

const legalPages = {
  "/legal/privacy": {
    title: "Información sobre datos personales",
    updated: "22 de octubre de 2026",
    sections: [
      {
        title: "Responsable del tratamiento",
        paragraphs: [
          "Esta información explica, de forma general, cómo Taller del Profe utiliza los datos que facilitas al realizar una compra. Para consultas sobre tus datos, escribe a amirocc@hotmail.com.",
        ],
      },
      {
        title: "Uso de los datos de compra",
        paragraphs: [
          "Los datos que solicitemos al comprar —por ejemplo, nombre, correo electrónico, teléfono y dirección— se utilizan exclusivamente para gestionar la compra del producto: confirmar el pedido y el pago, coordinar el envío y la entrega, y comunicarnos contigo sobre esa compra. No utilizamos esos datos para enviarte publicidad no relacionada con tu pedido.",
          "Para completar la compra, los datos estrictamente necesarios pueden ser tratados por los proveedores del pago (Bold), del envío o de los mensajes relacionados con el pedido. No guardamos números de tarjeta ni códigos de seguridad; el pago se realiza en la plataforma de Bold.",
          "El sitio también guarda en tu navegador el carrito y preferencias de idioma y moneda para mantener las funciones que eliges. No ingreses información sensible que no sea necesaria para comprar.",
        ],
      },
      {
        title: "Consultas sobre tus datos",
        paragraphs: [
          "Puedes escribir a amirocc@hotmail.com para consultar o solicitar la corrección de los datos asociados con tu compra. Las solicitudes se atenderán conforme a las normas de protección de datos que resulten aplicables.",
        ],
      },
      {
        title: "Conservación",
        paragraphs: [
          "Los datos se conservan durante el tiempo necesario para completar y atender la compra y para cumplir las obligaciones legales aplicables.",
        ],
      },
    ],
  },
  "/legal/terms": {
    title: "Términos y condiciones de uso y compra",
    updated: "22 de octubre de 2026",
    sections: [
      {
        title: "Identificación del vendedor",
        paragraphs: [
          "La tienda Taller del Profe es operada por Oscar Amir Camacho Cruz. Para consultas puedes escribir a amirocc@hotmail.com. Completa los datos del vendedor antes de aceptar pedidos en producción.",
        ],
      },
      {
        title: "Catálogo, disponibilidad y precios",
        paragraphs: [
          "Las obras ofrecidas son piezas de arte. Las fotografías y colores pueden variar según la pantalla. La ficha de cada obra describe sus características y disponibilidad; una obra marcada como vendida no está disponible.",
          "Los precios se muestran en la moneda indicada en la página. Las conversiones a otras monedas son informativas y pueden variar; el importe y la moneda que confirma Bold antes del pago son los aplicables a la transacción. Los gastos de envío, impuestos u otros cargos, si corresponden, deben informarse antes de finalizar la compra.",
        ],
      },
      {
        title: "Pedido, pago y confirmación",
        paragraphs: [
          "Enviar un pedido inicia el proceso de compra, pero no confirma por sí solo el pago ni garantiza la reserva definitiva de la obra. La compra se considera pagada cuando Bold confirma la transacción. No compartas datos de tarjeta por correo o formularios de contacto.",
          "Al completar una compra debes proporcionar información correcta y un correo válido para recibir comunicaciones del pedido. Te enviaremos confirmaciones y avisos operativos relacionados con la transacción.",
        ],
      },
      {
        title: "Envíos, retracto, cambios y garantías",
        paragraphs: [
          "Las condiciones, costo y plazo estimado de envío deben confirmarse con el comprador antes del pago, según destino, dimensiones y embalaje de la obra. Para coordinar una entrega o reportar daños, escribe a amirocc@hotmail.com e incluye el número de pedido.",
          "Los derechos legales del consumidor, incluidas las garantías y el derecho de retracto cuando sea aplicable, se rigen por la normativa vigente. En Colombia, el retracto está sujeto a los términos, plazos y excepciones de la Ley 1480 de 2011; no se limita por estos términos. Para ejercerlo o solicitar una garantía, contáctanos oportunamente. Si una obra se personaliza o existe otra excepción legal aplicable, se informará antes de la compra.",
          "No publiques una promesa de devoluciones, tiempos de entrega o exclusiones hasta que el vendedor haya definido cómo puede cumplirla. Estos términos no eliminan derechos irrenunciables del consumidor.",
        ],
      },
      {
        title: "Uso del sitio y propiedad intelectual",
        paragraphs: [
          "No intentes interferir con la seguridad o disponibilidad de la página, acceder a cuentas ajenas ni utilizar el sitio para actividades ilícitas. Los textos, fotografías y obras pertenecen a sus respectivos titulares. Comprar una obra física no transfiere derechos de reproducción, distribución o uso comercial de su imagen.",
        ],
      },
      {
        title: "Atención y cambios",
        paragraphs: [
          "Para preguntas, reclamaciones o solicitudes relacionadas con una compra, escribe a amirocc@hotmail.com. Publicaremos aquí cualquier modificación de estos términos con su fecha de actualización.",
        ],
      },
    ],
  },
  "/legal/cookies": {
    title: "Información sobre cookies y almacenamiento",
    updated: "22 de octubre de 2026",
    sections: [
      {
        title: "Qué utiliza actualmente esta página",
        paragraphs: [
          "Este sitio utiliza almacenamiento del navegador para recordar el carrito y tus preferencias de idioma y moneda. Esa información sirve para que la tienda funcione como esperas. El navegador también puede guardar la preferencia que eliges en este aviso.",
          "No usamos estos datos del navegador para enviarte publicidad. El carrito y las preferencias se guardan en tu dispositivo y puedes borrarlos desde la configuración de tu navegador; si lo haces, el carrito o tus preferencias podrían reiniciarse.",
        ],
      },
      {
        title: "Tu elección",
        paragraphs: [
          "El aviso te permite aceptar o continuar solo con el almacenamiento necesario para el funcionamiento de la tienda. Puedes cambiar tu elección desde “Preferencias de cookies” al pie de página.",
        ],
      },
      {
        title: "Servicios relacionados con tu compra",
        paragraphs: [
          "Bold gestiona el pago en su plataforma. Sus propios servicios pueden utilizar tecnologías sujetas a sus políticas cuando los visitas.",
        ],
      },
    ],
  },
  "/legal/shipping-returns": {
    title: "Información de envíos, retracto y garantías",
    updated: "22 de octubre de 2026",
    sections: [
      {
        title: "Envíos",
        paragraphs: [
          "Las obras se embalan para su transporte y cada envío se cotiza según el tamaño de la pieza y la dirección de entrega. Antes de pagar, solicita y confirma el costo, transportadora, cobertura y plazo estimado. No se debe interpretar un plazo estimado como garantía de entrega en una fecha concreta.",
          "Al recibir el paquete, revisa su estado y conserva el embalaje. Si detectas daños o una novedad, comunícate cuanto antes a amirocc@hotmail.com con tu número de pedido y evidencia del estado del paquete.",
        ],
      },
      {
        title: "Derecho de retracto y devoluciones",
        paragraphs: [
          "Cuando la compra esté sujeta al derecho de retracto previsto en la legislación colombiana, podrás ejercerlo dentro del término y bajo las condiciones legales aplicables, comunicándolo de forma clara a amirocc@hotmail.com e identificando el pedido. Se aplicarán las reglas legales sobre devolución del producto, costos y reembolso.",
          "La Ley 1480 de 2011 contempla excepciones al retracto en ciertos casos. La aplicación de una excepción depende de las características concretas de la venta y no se presume solo porque se trate de una obra de arte. Ninguna regla de esta página restringe la garantía legal ni otros derechos irrenunciables.",
        ],
      },
      {
        title: "Garantías y contacto",
        paragraphs: [
          "Si la obra presenta un problema de calidad, idoneidad o seguridad, contáctanos para tramitar la garantía conforme a la ley y a las características del producto. Indica el pedido y describe el problema; te informaremos los pasos para revisar el caso.",
          "Antes de publicar, completa y verifica los datos del vendedor, las tarifas, destinos y tiempos de envío que realmente puedes ofrecer. Contacto: amirocc@hotmail.com.",
        ],
      },
    ],
  },
};

export default function LegalPage() {
  const { pathname } = useLocation();
  const page = legalPages[pathname];

  if (!page) {
    return (
      <div className="container mx-auto max-w-3xl px-4 py-20">
        <h1 className="font-serif text-3xl">Información legal</h1>
        <ul className="mt-6 list-disc space-y-2 pl-6">
          {Object.entries(legalPages).map(([path, item]) => (
            <li key={path}><Link className="underline" to={path}>{item.title}</Link></li>
          ))}
        </ul>
      </div>
    );
  }

  return (
    <article className="container mx-auto max-w-3xl px-4 py-16 md:py-24" data-testid="legal-page">
      <p className="text-xs uppercase tracking-widest text-muted-foreground">Taller del Profe · Información legal</p>
      <h1 className="mt-4 font-serif text-3xl md:text-5xl">{page.title}</h1>
      <p className="mt-4 text-sm text-muted-foreground">Última actualización: {page.updated}</p>
      <div className="mt-10 space-y-8">
        {page.sections.map((section) => (
          <section key={section.title}>
            <h2 className="font-serif text-xl md:text-2xl">{section.title}</h2>
            {section.paragraphs.map((paragraph) => (
              <p key={paragraph} className="mt-3 leading-7 text-muted-foreground">{paragraph}</p>
            ))}
          </section>
        ))}
      </div>
      <Link to="/" className="mt-8 inline-block text-sm underline underline-offset-4">Volver al inicio</Link>
    </article>
  );
}
